export const Testing = {
    "答题提示": "Answering hints",
    "点击查看答题提示": "Tap to view answering hints",
    "知识卡": "Knowledge card",
    "资料": "Material",
    "共":"",
    "题":"questions",
    "被打回":"Be returned",
    "用时":"Time",
    "不限时":"Unlimited time",
    "时":"hour",
    "分":"minutes",
    "请选择":"Please select",
    "匿名":"Anonymous",
    "实名":"Real name",
    "得分":"Score: ",
    "回答正确":"Correct",
    "回答错误":"Wrong",
    "不能大于此题分数":"Cannot be greater than the score of this question",
    "学生答案":"Students' answers: ",
    "回答错误得分0":"回答错误, 得分: 0",
    "作答者正确率":"作答者正确率: ",
    "份待批改":" need to be corrected",
    "还有":"",
    "道题未作答":"questions left unanswered",
    "您只有一次机会，提交后不可更改":"You only have one chance, which cannot be changed after submitting",
    "提交成功":"Submitted successfully",
    "您的试卷已经成功提交":"Your test paper has been submitted successfully",
    "是否直接前往发布测试":"Whether to go directly to the release test?",
    "前往发布设置":"Go to publish settings",
    "稍后再说":"Later",
    "普通测试":"General test",
    "考试":"Examination",
    "测试类型":"Test Type",
    "预览试题":"Preview",
    "测试标题":"Test title",
    "测试设置":"Test settings",
    "是否同步发送给学生":"Send to students synchronously",
    "测试详情":"Test details",
    "开启后在完成添加的同时会将本活动发布给学生":"After opening, this activity will be published to students when the addition is completed",
    "限时答题":"Time limited answer",
    "不随机":"Not random",
    "按题型抽取":"Draw by question type",
    "按题目区块抽取":"Extract by topic block",
    "添加测试":"Add test",
    "是否发布测试":"Whether to publish the test?",
    "发布中":"Publishing...",
    "确认发布":"Confirm publish",
    "天":"day",
    "0分钟":"0 minutes",
    "选":"Person who chooses ",
    "的人":"",
    "正确学生":"Correct students",
    "错误学生":"Wrong student",
    "查看学生答案":"View student answers",
    "确定打回该学生的试卷吗":"Are you sure to return the student's test paper?",
    "打回成功":"return successfully",
    "已经是最后一个学生":"It is the last",
    "已经是第一个学生":"Is already the first student",
    "您的试卷未提交可以继续作答哦":"Your test paper has not been submitted, you can continue to answer!",
    "您的测试已被老师打回了需要重新提交才算成绩哦":"Your test has been returned by the teacher. You need to resubmit it to calculate your score!",
    "点击下方查看试卷可以查看作答情况":"Click 'View Test Paper' below to check the answers",
    "等待老师批改点击下方查看试卷可以查看作答情况":"Wait for the teacher to correct, click 'View Test Paper' below to check the response",
    "成绩未公布请您耐心等待":"The results have not been published, please wait patiently!",
    "测试已结束点击下方查看试卷可以查看试卷":"The test has ended. Click 'View Test Paper' below to view the test paper",
    "本试卷共":"This test paper has ",
    "本场考试已开启防切屏模式切换页面":"The anti screen switching mode has been enabled for this exam,switch pages ",
    "次后将强制交卷请谨慎答题勿退出答题页面":" times,the paper will be handed in compulsorily. Please answer carefully and do not exit the answer page!",
    "线下测试":"Offline test",
    "查看试卷":"View test paper",
    "重新答题":"Answer again",
    "继续答题":"Continue to answer",
    "成绩不公布":"Score not be published",
    "测试已结束, 未参与!":"The test has ended, not participated!",
    "我的作答":"My answer",
    "测试已结束系统已自动收取试卷":"The test has ended, and the system has automatically collected the test papers",
    "您已跳出答题页面":"You have jumped out of the answer page ",
    "次系统将在":"times, the system will automatic submission after ",
    "后自动交卷":" !",
    "次再跳出":" times, jump out",
    "次将":"times more,",
    "自动交卷":"The paper will be handed in automatically.",
    "请谨慎答题":"Please answer carefully!",
    "15秒后系统将自动交卷":"After 15 seconds, the system will automatically hand in the paper!",
    "答题过程中不允许回退":"No rollback is allowed during answer",
    "闯关答题不允许回退":"No rollback is allowed during barrier answer",
    "您的网络出现问题答案保存失败请检查当前网络是否有问题恢复网络后请重新答题":"There is a problem with your network. Failed to save the answer! Please check whether there is a problem with the current network. Please answer the question again after the network is restored",
    "确定提交当前试卷":"Are you sure to submit the current test paper?",
    "您是否进行返回当前返回将被记录为切屏":"Do you want to return? The current return will be recorded as screen cut ",
    "1次":"for 1 time",
    "放弃返回":"Discard return",
    "继续返回":"Continue return",
    "客观题":"Objective question",
    "正确":"Correct",
    "错误":"Wrong",
    "主观题":"Subjective question",
    "全部解析":"All analysis",
    "错题解析":"Analysis of wrong questions",
    "试卷还未批改暂无数据分析":"The test paper has not been corrected and there is no data analysis",
    "请确认是否要":"Please confirm whether to",
    "打回后, 学生需要重新提交":"After returning, the student needs to resubmit",
    "催交的学生将会受到催交信息":"Expedited students will receive expediting information",
    "确认催交":"Confirm expediting",
    "待批":"To be corrected",
    "批阅状态":"Approval status",
    "删除测试":"Delete Test",
    "确定要删除测试吗":"Are you sure to delete the test?",
    "抽题测试":"Extracting questions test",
    "题目顺序随机打乱":"The order of the questions is random",
    "选项顺序随机打乱":"The order of options is random",
    "答案公布设置":"Answer publishing settings",
    "成绩公布设置":"Score publishing settings",
    "交卷后允许查看试卷":"Allow to view the test paper after handing in",
    "多选题计分方式":"Scoring method for multiple choice questions",
    "填空题计分方式":"Scoring method for blank filling questions",
    "填空题大小写敏感":"Blank filling questions are case sensitive",
    "允许复制试题":"Allow copying test questions",
    "允许粘贴答案":"Allow pasting answers",
    "答案展示样式":"Answer presentation style",
    "答题过程可以回退":"The answer process can be rolled back",
    "目前该测试考试正在进行中无法进行切屏设置":"At present, the test (examination) is in progress, and screen switching settings cannot be performed",
    "切屏后强制交卷":"Forced submission after screen cutting",
    "切屏次数":"Screen cutting times",
    "学生切屏页面超过后将强制交卷":"Students will be forced to hand in the paper after the screen cutting page exceeds",
    "请输入次数":"Please enter the number of times",
    "当学生在当前设备上每离开一次答题界面将给予提示如果切换页面超出上限后将被强制交卷":"When students are on the current device, they will be prompted every time they leave the answer interface. If the switching page exceeds the upper limit, they will be forced to hand in their papers.",
    "注设置次数时请考虑设备及网络等异常情况例如手机端会存在电话呼入电脑端广告弹框不小心无操作切出等":"Tips: When setting the number of times, please consider the abnormal conditions of the device and network, for example, there will be incoming calls on the mobile phone, pop-up ads on the computer, and careless and non operational cutouts;",
    "特别注意电脑端作答文件题时上传图片算作1次切屏手机端由于不同的操作系统会导致切换到手机桌面其他应用或者文件题上传图片时会每5秒记一次切屏":"Special attention: when the computer terminal answers the file question, the uploaded picture is counted as one screen cut; Due to different operating systems on the mobile phone, screen cuts will be recorded every 5 seconds when you switch to the mobile desktop, other applications or file titles to upload pictures!",
    "允许多设备作答":"Allow multiple devices to answer",
    "不随机打乱":"No random disturbance",
    "全题目顺序随机打乱":"The order of all questions is randomly disordered",
    "同一题型内题目顺序随机打乱":"The order of questions in the same question type is randomly disordered",
    "不公布":"Not published",
    "学生交卷后公布答案":"Publish answers after handing in the papers",
    "到截止时间公布答案":"Publish the answers by the deadline",
    "成绩出来之后立即看到":"See the score immediately after correction",
    "多选少选错选不得分":"No score for multiple, fewer or wrong choices",
    "少选时按照选项个数计分":"Score according to the number of options when fewer options are selected",
    "少选时得一半分数":"Half of the points will be given if fewer choices are made",
    "与答案不全匹配时手动批改":"If the answer is not completely matched, manually correct it",
    "与答案不全匹配时机器自动批改":"If the answer is not completely matched, the machine will automatically correct it",
    "与答案不全匹配时自动0分":"If the answer is not completely matched, 0 point will be given automatically",
    "不敏感":"No",
    "大小写敏感":"Yes",
    "一页式":"One page",
    "单题卡片式":"Single question card",
    "目前该测试考试正在进行中若更改设置可能影响学生的答题数据":"At present, the test (examination) is in progress. If the setting is changed, the answer data of students may be affected",
    "确定更改":"Confirm changes",
    "目前该测试考试已结束若更改设置可能影响学生的答题结果":"At present, the test (examination) has ended. If you change the settings, the answer results of the students may be affected",
    "当前设置为一页式答题过程可以回退设置无效":"The current setting is one page, and the answer process can be rolled back. The setting is invalid!",
    "请输入0100之间的整数":"Please enter an integer between 0 and 100",
    "随机抽取试题":"Randomly select test questions",
    "题目数量":"Number of questions",
    "最多可选":"Can select up to ",
    "每张试卷":"Each test paper",
    "从第":"Extract from question ",
    "题第":"to question ",
    "题 抽取":" ",
    "增加抽取范围":"Increase extraction range",
    "随机抽取的题目个数不能全部为0":"The number of randomly selected questions cannot be all 0",
    "没有该题":"No such question",
    "最多抽取":'Extract at most',
    "测试未开始":"Test not started",
    "距离开始还剩":"Will start in",
    "测试进行中":"Test in progress",
    "建议不要修改测试参数以免影响学生答题数据":"It is recommended not to modify the test parameters to avoid affecting the students' answer data!",
    "请确认是否结束该测试":"Please confirm whether to end the test",
    "批阅测试":"Review",
    "测试分析":"Analysis",
    "手动结束测试":"manually ending",
    "闯关测试":"Pass test",
    "练习":"Practice",
    "开始闯关":"Start",
    "闯关完成":"Complete",
    "继续闯关":"Continue",
    "薄弱知识点":"Weak knowledge points",
    "提升":"Improve",
    "未闯关":"Beginner",
    "已完成":"Completed",
    "闯关中":"In progress",
    "未开始":"Not started",
    "闯关情况":"Pass",
    "进行中":"In progress",
    "未参与":"Not participated",
    "正在提交中请稍后":"Submitting, please wait...",
    "提交失败请重试":"Submit failed, please try again",
    "确定继续闯关吗":"Are you sure to continue the challenge?",
    "AI批改":"AI Grading",
    "主观题AI批改未完成":"AI grading of subjective questions is not finished",
    "可触发AI批改或直接继续闯关":"Tap AI Grading to get the result, or continue the challenge to answer again",
    "AI批改中请稍后":"AI grading, please wait...",
    "AI批改失败可稍后重试或继续闯关":"AI grading failed. Please retry later or continue the challenge",
    "正在初始化闯关请稍后":"Initializing challenge, please wait...",
    "闯关初始化失败请重试":"Challenge initialization failed, please try again",
}